export class Userdata {
    public userName: string = "Пользователь"; // имя пользователея
    public userNameLabel: string = "Пользователь";
    public currentRegionFias: string = "";
    public currentRegionString: string = "";
    public userConnectedBool: boolean = false;
    public userStatusString: string = "Знаток";
}
